import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getUserById } from './userSlice';
import { loadUserFromStorage } from './authSlice';

export const syncUserStatus = createAsyncThunk(
  'sync/userStatus',
  async (_, { dispatch, getState }) => {
    const { auth: { userDetails } } = getState();
    if (userDetails?.userId) {
      await dispatch(getUserById(userDetails.userId));
      dispatch(loadUserFromStorage());
    }
  }
);

const syncSlice = createSlice({
  name: 'sync',
  initialState: {
    lastSync: null,
    syncing: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(syncUserStatus.pending, (state) => {
        state.syncing = true;
      })
      .addCase(syncUserStatus.fulfilled, (state) => {
        state.syncing = false;
        state.lastSync = Date.now();
      })
      .addCase(syncUserStatus.rejected, (state, action) => {
        state.syncing = false;
        state.error = action.error.message;
      });
  }
});

export default syncSlice.reducer;